// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__vm15B","sliderLine":"Slider_sliderLine__x9aPE","sliderRange":"Slider_sliderRange___89ie","sliderButton":"Slider_sliderButton__rDVFH"};